"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Counter = void 0;
var Counter_1 = __importDefault(require("./Counter"));
exports.Counter = Counter_1.default;
exports.default = Counter_1.default;
//# sourceMappingURL=index.js.map